import validate from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45to_45result_45global from "/home/forge/client-solarrechner.der-solarteur.com/middleware/redirectToResult.global.ts";
import manifest_45route_45rule from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45to_45result_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}